// extracted by mini-css-extract-plugin
export default {"button":"button__kY9AT"};
    if(module.hot) {
      // 1790586286541
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  